module.exports = __webpack_public_path__ + "assets/img/driver-btn-2bbce5ba.png";